import { render, staticRenderFns } from "./SettingsTeamMembers.vue?vue&type=template&id=252b2128&"
import script from "./SettingsTeamMembers.vue?vue&type=script&lang=js&"
export * from "./SettingsTeamMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports